import React, { lazy, Suspense, useContext, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useHistory, useLocation } from 'react-router-dom';

import {
    FAVOURITES_ROUTE,
    PROFILE_ROUTE
} from '../../../utils/consts';

import { Context } from "../../../index";

import {
    getMessagesTargetRoute,
    isMessagesRoute,
    formatMessagesBadge
} from "../../../utils/chat/messagesNavigation";

import chatIcon from "../../../Assets/BottomMenu/chatIcon.svg";
import profilePlaceholder from '../../../Assets/profile.svg';
import Favourites from '../../../Assets/hearts/heart-black.svg';

import styles from './UserMiniProfile.module.css';
import { reachGoal } from "../../../utils/metrika/metrika";

const RegistrationForm =
    lazy(() =>
        import('../../modals/UserForms/RegistrationForm/RegistrationForm')
    );

const UserMiniProfile = observer(() => {
    const { user, messages } = useContext(Context);

    const history = useHistory();
    const location = useLocation();

    const totalUnreadCount = messages.totalUnreadCount;
    const isChatPage = isMessagesRoute(location.pathname);
    const isFavouritesPage =
        location.pathname.startsWith(FAVOURITES_ROUTE);

    const [showRegistrationModal, setShowRegistrationModal] =
        useState(false);

    const [registrationFormLoaded, setRegistrationFormLoaded] =
        useState(false);

    const openRegistration = () => {
        setRegistrationFormLoaded(true);
        setShowRegistrationModal(true);
    };

    const getProfileImageUrl = () => {
        if (
            !user.UserData ||
            !user.UserData.id ||
            !user.UserData.img ||
            user.UserData.img === 'EMPTY'
        ) {
            return null;
        }

        if (typeof user.UserData.img !== 'string') {
            return null;
        }

        return (
            `${process.env.REACT_APP_API_URL}` +
            `users/user${user.UserData.id}/${user.UserData.img}`
        );
    };

    const profileImageUrl = getProfileImageUrl();

    const handleFavoritesClick = (event) => {
        event.stopPropagation();

        if (user.isAuth && user.UserData?.id) {
            history.push(FAVOURITES_ROUTE);
            reachGoal("history.push(FAVOURITES_ROUTE) NAVIGATION");
            return;
        }

        openRegistration();
    };

    const handleChatClick = () => {
        history.push(getMessagesTargetRoute());
        reachGoal("history.push(MESSAGES_ROUTE) NAVIGATION");
    };

    const handleProfileClick = () => {
        if (!user.UserData?.id) {
            return;
        }

        history.push(`${PROFILE_ROUTE}/${user.UserData.id}`);
        reachGoal("history.push(`${PROFILE_ROUTE} NAVIGATION`)");
    };

    return (
        <>
            <div className={styles.navContainer}>
                <button
                    type="button"
                    className={`${styles.navIconButton} ${isChatPage ? styles.navIconButtonActive : ''}`}
                    onClick={handleChatClick}
                    title="Сообщения"
                    aria-label="Сообщения"
                >
                    <img
                        src={chatIcon}
                        alt=""
                        className={`${styles.navIcon} ${styles.chatIcon}`}
                    />

                    {totalUnreadCount > 0 && (
                        <span className={styles.badge}>
                            {formatMessagesBadge(totalUnreadCount)}
                        </span>
                    )}
                </button>

                <button
                    type="button"
                    className={`${styles.navIconButton} ${isFavouritesPage ? styles.navIconButtonActive : ''}`}
                    onClick={handleFavoritesClick}
                    title="Избранное"
                    aria-label="Избранное"
                >
                    <img
                        src={Favourites}
                        alt=""
                        className={`${styles.navIcon} ${styles.favoriteIcon}`}
                    />
                </button>

                {user.isAuth && user.UserData ? (
                    <button
                        type="button"
                        className={styles.profileButton}
                        onClick={handleProfileClick}
                        title={user.UserData.nickname || 'Профиль'}
                        aria-label="Открыть профиль"
                    >
                        <span className={styles.profileAvatarContainer}>
                            <img
                                src={profileImageUrl || profilePlaceholder}
                                alt=""
                                className={styles.profileAvatarImg}
                            />
                        </span>

                        <span className={styles.profileNickname}>
                            {user.UserData.nickname || 'Пользователь'}
                        </span>
                    </button>
                ) : (
                    <button
                        type="button"
                        className={styles.loginButton}
                        onClick={openRegistration}
                    >
                        Войти
                    </button>
                )}
            </div>

            {registrationFormLoaded && (
                <Suspense fallback={null}>
                    <RegistrationForm
                        show={showRegistrationModal}
                        onHide={() => setShowRegistrationModal(false)}
                    />
                </Suspense>
            )}
        </>
    );
});

export default UserMiniProfile;
